import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoney = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 15,
	viewBox: "0 0 18 15",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.77321 1.475C1.33237 1.475 0.975 1.83237 0.975 2.27321V9.9875C0.975 10.4283 1.33237 10.7857 1.77321 10.7857H12.7018C13.1426 10.7857 13.5 10.4283 13.5 9.9875V2.27321C13.5 1.83237 13.1426 1.475 12.7018 1.475H1.77321ZM0 2.27321C0 1.2939 0.793895 0.5 1.77321 0.5H12.7018C13.6811 0.5 14.475 1.2939 14.475 2.27321V9.9875C14.475 10.9668 13.6811 11.7607 12.7018 11.7607H1.77321C0.793895 11.7607 0 10.9668 0 9.9875V2.27321Z",
			fill: "#313131"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.23834 4.68887C6.44245 4.68887 5.79727 5.33406 5.79727 6.12994C5.79727 6.92582 6.44245 7.57101 7.23834 7.57101C8.03422 7.57101 8.67941 6.92582 8.67941 6.12994C8.67941 5.33406 8.03422 4.68887 7.23834 4.68887ZM4.82227 6.12994C4.82227 4.79558 5.90398 3.71387 7.23834 3.71387C8.5727 3.71387 9.65441 4.79558 9.65441 6.12994C9.65441 7.4643 8.5727 8.54601 7.23834 8.54601C5.90398 8.54601 4.82227 7.4643 4.82227 6.12994Z",
			fill: "#313131"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.2021 6.28613C17.4713 6.28613 17.6896 6.50439 17.6896 6.77363V13.2022C17.6896 13.6725 17.5027 14.1235 17.1702 14.4561C16.8377 14.7886 16.3866 14.9754 15.9163 14.9754H4.34492C4.07568 14.9754 3.85742 14.7572 3.85742 14.4879C3.85742 14.2187 4.07568 14.0004 4.34492 14.0004H15.9163C16.128 14.0004 16.3311 13.9163 16.4808 13.7666C16.6305 13.6169 16.7146 13.4139 16.7146 13.2022V6.77363C16.7146 6.50439 16.9328 6.28613 17.2021 6.28613Z",
			fill: "#313131"
		})
	]
});
const ForwardRef = forwardRef(SvgMoney);
export { ForwardRef as ReactComponent };
